export const getSelectYearRange = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - 1980 + 1 }, (_, i) => currentYear - i);
}

export const getLabelFromType = (typeList, value) => {
  return typeList.find(type => type.value === value)?.label;
}

export const formatDate = (dateString) => {
  if (!dateString) return ''
  return new Date(dateString).toLocaleDateString('ko-KR')
}

export const searchAddress = () => {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    new daum.Postcode({
      oncomplete: function(data) {
        resolve(data)
      },
      onerror: function(err) {
        reject(err)
      }
    }).open()
  })
}